import React, { useState, useEffect } from 'react';
import TutorFormWizard from '../forms/TutorFormWizard';
import TutorDashboard from '../views/Tutor/TutorDashboard';
import TutorDocsPending from '../components/TutorDocsPending';

const TutorHomePage = () => {
  const [regStatus, setRegStatus] = useState(localStorage.getItem('reg_status'));
  const [showWizardCompletion, setShowWizardCompletion] = useState(false);

  useEffect(() => {
    // Function to check for localStorage changes
    const checkRegStatusChange = () => {
      const currentRegStatus = localStorage.getItem('reg_status');
      if (currentRegStatus !== regStatus) {
        setRegStatus(currentRegStatus);
      }
    };

    // Listen for wizard completion event
    const handleWizardCompletion = () => {
      console.log('Wizard completion event received in TutorHomePage');
      setShowWizardCompletion(true);
      // Update reg_status after a delay to show completion message
      setTimeout(() => {
        setRegStatus(localStorage.getItem('reg_status'));
        setShowWizardCompletion(false);
      }, 2000);
    };

    // Check for changes every second
    const interval = setInterval(checkRegStatusChange, 1000);

    // Listen for storage events (works for changes from other tabs)
    const handleStorageChange = (e) => {
      if (e.key === 'reg_status') {
        setRegStatus(e.newValue);
      }
    };

    window.addEventListener('storage', handleStorageChange);
    window.addEventListener('wizardCompleted', handleWizardCompletion);

    // Cleanup
    return () => {
      clearInterval(interval);
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('wizardCompleted', handleWizardCompletion);
    };
  }, [regStatus]);

  // Convert regStatus to number for comparison
  const statusNum = parseInt(regStatus, 10);

  // Decide what to show based on reg_status
  const renderContent = () => {
    // Show wizard completion message briefly
    if (showWizardCompletion) {
      return <TutorFormWizard />;
    }

    // reg_status = 0 or null: show registration wizard
    if (regStatus === '0' || regStatus === 0 || regStatus === null || !regStatus || isNaN(statusNum)) {
      return <TutorFormWizard />;
    }

    // reg_status = 1: documents pending review (wizard completed)
    if (statusNum === 1) {
      return <TutorDocsPending />;
    }

    // reg_status >= 2: fully registered, show dashboard
    if (statusNum >= 2) {
      return <TutorDashboard />;
    }

    // fallback
    return <TutorFormWizard />;
  };

  return (
    <div>
      {renderContent()}
    </div>
  );
};

export default TutorHomePage;
